import { setAttribution } from '@common/vanilla_ui/tracking/attribution';

const PROGRAMS = {
  DATA_SCIENCE: 'data_science',
  ACADEMY: 'software_development',
  DEVOPS: 'devops',
  AI_ML: 'ai_ml',
};


const radioInput = document.getElementsByClassName('form-field__radio')[0];

const initialize = () => {
  radioInput?.addEventListener('click', () => {
    const programInput = document.getElementsByName('program');
    const selectedProgram = Array.from(programInput).find(
      (el) => el.checked,
    )?.value;
    const attributionProgram = PROGRAMS[selectedProgram.toUpperCase()];
    setAttribution('review_homepage_form', {
      program: attributionProgram,
    });
  });
};

export default {
  initialize,
};
